import { DecoratedFormProps, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { Dispatch } from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/serviceLocationform.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import { asyncPersistServiceLocation } from 'src/store/actions/service-location-actions';
export interface ServiceLocationFormData {
    id: string;
    title: string;
    isPrivate: boolean;
    description: string;
}
interface ServiceLocationFormProps {}

type InjectedProps = InjectedFormProps<ServiceLocationFormData, ServiceLocationFormProps>;

const validators: Validators<ServiceLocationFormData> = {
    title: [required({ message: 'Name is required.' }), maxLength({ max: 255 })],
    description: [maxLength({ max: 255 })],
};

const ServiceLocationForm: React.FunctionComponent<InjectedProps & ServiceLocationFormProps> = ({
    handleSubmit,
    error,
    dirty,
    submitting,
    initialValues,
}: InjectedProps & ServiceLocationFormProps) => {
    const isNew = !initialValues || !initialValues.id;

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="title"
                type="text"
                validate={validators.title}
                wrapperConfig={{
                    label: 'Name *',
                }}
            />

            <FieldInput
                name="description"
                type="text"
                validate={validators.description}
                wrapperConfig={{
                    label: 'Description Info:',
                }}
            />
            <div className={'mb-3'}>
                <FieldInput
                    name="isPrivate"
                    type="checkbox"
                    wrapperConfig={{
                        label: 'Private',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
            </div>

            <div className={classNames(styles.actions)}>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                </button>
                <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.SERVICE_LOCATIONS_LIST)}>
                    <FontAwesomeIcon icon={faBan} /> Cancel
                </Link>
            </div>
        </form>
    );
};
export default reduxForm<ServiceLocationFormData, ServiceLocationFormProps>({
    form: 'serviceLocation-form',
    validate(
        values: ServiceLocationFormData,
        props: DecoratedFormProps<ServiceLocationFormData, ServiceLocationFormProps, string>,
    ): FormErrors<ServiceLocationFormData, string> {
        const errors: FormErrors<ServiceLocationFormData, string> = {};
        return errors;
    },
    onSubmit: asyncPersistServiceLocation,
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<ServiceLocationFormData, ServiceLocationFormProps, string>,
    ) {
        const isNew = !props.initialValues || !props.initialValues.id;

        toast.success(`Service Location was successfully ${isNew ? 'created' : 'updated'}.`);
        dispatch(push(Router.generate(routes.SERVICE_LOCATIONS_LIST)));
    },
    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(ServiceLocationForm);
